import { render, staticRenderFns } from "./BuildsComp.vue?vue&type=template&id=0e0d9fec&scoped=true&"
import script from "./BuildsComp.vue?vue&type=script&lang=ts&"
export * from "./BuildsComp.vue?vue&type=script&lang=ts&"
import style0 from "./BuildsComp.vue?vue&type=style&index=0&id=0e0d9fec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0d9fec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VChip,VDialog,VIcon,VProgressCircular})
